export type TErrorType = 'None' | 'requiredField' | 'invalidInput' | 'thirdParty' | 'notEligible';
export type TFieldState = 'neutral' | 'success' | 'error';
export type TInputField = { value: string, state: TFieldState, errorType: TErrorType };
// neutral state should allow no value
export type TBooleanField = { value: boolean | null, state: TFieldState, errorType: TErrorType };

export const ACTIONS = {
    BULK_UPDATE_FIELD: 'bulk_update_field',
    UPDATE_FIELD: 'update_field',
    RESET_FIELD: 'reset_field',
} as const;

export type FieldActions = BulkUpdateFieldAction | UpdateFieldAction | ResetFieldAction;

export type BulkUpdateFieldAction = {
    type: string;
    payload: TAcquisitionState
}

export type UpdateFieldAction = {
    type: string;
    payload: {
        field: keyof TAcquisitionState;
        value?: string;
        state?: TFieldState;
        errorType?: TErrorType;
    }
}

export type ResetFieldAction = {
    type: string;
    payload: {
        field: keyof TAcquisitionState;
    }
}

export type TAcquisitionState = Partial<{
    authorizedUserDateOfBirthDay: Partial<TInputField>,
    authorizedUserDateOfBirthMonth: Partial<TInputField>,
    authorizedUserDateOfBirthYear: Partial<TInputField>,
    authorizedUserFirstName: Partial<TInputField>,
    authorizedUserLastName: Partial<TInputField>,
    authorizedUserMiddleInitial: Partial<TInputField>,
    authorizedUserSpouse: Partial<TBooleanField>,
    dateOfBirthDay: Partial<TInputField>,
    dateOfBirthMonth: Partial<TInputField>,
    dateOfBirthYear: Partial<TInputField>,
    emailAddress: Partial<TInputField>,
    firstName: Partial<TInputField>,
    homeAddressLineOne: Partial<TInputField>,
    homeAddressLineTwo: Partial<TInputField>,
    homeAddressCity: Partial<TInputField>,
    homeAddressState: Partial<TInputField>,
    homeAddressZipCode: Partial<TInputField>,
    lastName: Partial<TInputField>,
    mailingAddressLineOne: Partial<TInputField>,
    mailingAddressLineTwo: Partial<TInputField>,
    mailingAddressCity: Partial<TInputField>,
    mailingAddressState: Partial<TInputField>,
    mailingAddressZipCode: Partial<TInputField>,
    middleInitial: Partial<TInputField>,
    monthlyIncome: Partial<TInputField>,
    phoneNumber: Partial<TInputField>,
    ssn: Partial<TInputField>,
    suffix: Partial<TInputField>,
}>

export interface IAcquisitionStore {
    // Returns current state snapshot - always returns latest due to ref
    getState: () => TAcquisitionState;
    // Dispatch actions to update state
    dispatch: (action: FieldActions) => void;
    // Subscribe to state changes. Returns unsubscribe function.
    subscribe: (listener: () => void) => (() => void);
    getStateCopy: () => TAcquisitionState;
}
